import { CalculatorIcon, CheckCircleIcon } from '@heroicons/react/20/solid'

import patchwork from '../assets/patchwork-careers.webp'

export default function JobsHero(props) {
    const { isEnglish, anchorScroll } = props

    return (
        <div className="overflow-x-hidden">
            <div className='jobHeroPattern overflow-x-hidden heroPatternStarsH absolute top-0 left-0 translate-x-0 translate-y-20 sm:translate-x-14 sm:translate-y-32 -z-10' />
            <div className="relative isolate">
                <div className="jobHero mx-auto max-w-7xl">
                    <div className="mx-4 sm:mx-8 flex max-w-2xl flex-col gap-8 sm:gap-16 px-6 py-8 sm:px-12 sm:py-16 shadow-xl rounded-3xl ring-1 ring-white/10 lg:max-w-none lg:flex-row lg:items-center" style={{ backgroundColor: '#111827' }}>
                        <img
                            alt="Notre équipe"
                            src={patchwork}
                            className="h-50 w-full flex-none rounded-2xl object-cover shadow-xl lg:aspect-square lg:h-auto lg:max-w-sm"
                            loading="lazy"
                        />
                        <div className="w-full flex-auto">
                            <h4 className="text-2xl sm:text-3xl sm:text-4xl font-bold tracking-tight text-white">{isEnglish ? 'Join our team' : 'Rejoignez notre équipe'}</h4>
                            <p className="mt-0 sm:mt-2 text-md sm:text-lg leading-6 text-gray-200">
                                {isEnglish ? 'Start your new career as a dentist in France' : 'Dynamisez votre carrière avec Neomed'}
                            </p>
                            <ul
                                role="list"
                                className="mt-6 grid grid-cols-1 gap-x-8 gap-y-1 sm:gap-y-3 text-base leading-6 text-white sm:grid-cols-2"
                            >
                                {props.benefits.map((benefit) => (
                                    <li key={benefit} className="flex items-center gap-x-3 text-sm sm:text-base">
                                        <CheckCircleIcon aria-hidden="true" className="h-8 w-6 sm:h-7 sm:w-5 flex-none" />
                                        {benefit}
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-6 sm:mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
                                <button onClick={() => anchorScroll('#calculator')} className="flex cursor-pointer items-center rounded-xl bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm transition-all duration-200 hover:scale-[1.02] hover:shadow-lg">
                                    {isEnglish ? 'Calculate your salary' : 'Calculez votre salaire'}
                                    <CalculatorIcon className='w-5 h-5 ml-2' />
                                </button>
                                <div onClick={() => anchorScroll('#jobs')} className="text-sm cursor-pointer font-semibold leading-6 text-white hover:text-gray-200 transition-colors">
                                    {isEnglish ? 'See our job postings' : "Voir nos offres d'emploi"} &rarr;
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
